import { useNotify, useRefresh } from "ra-core";
import { useState } from "react";

/** Runs one drawer action at a time: names the running one (for its spinner), tells a failure, then refreshes the page */
export const useDrawerTask = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [running, setRunning] = useState<string | null>(null);
  const run = async (name: string, act: () => Promise<unknown>) => {
    setRunning(name);
    try {
      await act();
      refresh();
    } catch (error) {
      notify((error as Error).message, { type: "error" });
    } finally {
      setRunning(null);
    }
  };
  return { running, run };
};
